<div class="ng-autocomplete w-100">
    <ng-autocomplete 
      #searchInput
      [class]='classSearch'
      [data]="data"
      [searchKeyword]="keyword"
      placeholder="Buscar empresa socia"
      (selected)='selectSearch($event)'
      (inputChanged)='debouncedSearchInput($event)' 
      (inputCleared)='clearedInputSearch()'                              
      (closed)='closedSearchPanel()'                              
      [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate">                                 
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
        <a style="padding: 5px 15px;" class="f-s-12 p-10" [innerHTML]="item.tradename"></a>
        <p style="padding: 0px 20px; font-size: 9px !important; margin-bottom: 2px; margin-top: -4px;">
            <i class="fas fa-info-circle m-r-5"></i> {{item.document_str}}
        </p>
    </ng-template>   
    <ng-template #notFoundTemplate let-notFound>
      <p style="padding-top: 5px;
      margin-bottom: 5px;
      font-weight: 500;" *ngIf="isTypedSearch">No se encontraron registros</p>
    </ng-template>
  </div>